import axios from 'axios';

/**
 * Route translation service that translates our URL routing.
 */
export default class RouteTranslationService {
	/**
	 * @param {string} domainName The name of the domain, e.g. NL or BE (case insensitive).
	 * @param {boolean} allowCache
	 * @returns {Promise<object>} An object with route segments as keys and domain specific translations as values.
	 */
	static getRouteTranslationMapForDomain (domainName, allowCache = true) {
		return new Promise((resolve) => {
			if (!RouteTranslationService.cache.has(domainName) || !allowCache) {
				axios.get(`/api/v0/routesegmenttranslations?domain_name=${domainName}`)
					.then(({
						data,
					}) => {
						RouteTranslationService.cache.set(domainName, data);
						resolve(RouteTranslationService.cache.get(domainName));
					});
			} else {
				resolve(RouteTranslationService.cache.get(domainName));
			}
		});
	}
}

RouteTranslationService.cache = new Map();
